"use strict";
angular.module("viewLayoutModule", [])
    .controller("viewLayoutCtrl", ["$scope", "$q", "$modalInstance", "item", "trsHttpService", "modalDialog", function($scope, $q, $modalInstance, item, trsHttpService, modalDialog, ) {
        initStatus();
        initData();

        /** [initStatus description]初始化状态 */
        function initStatus() {
            $scope.data = {
                curManu: {}, //当前选中稿件
                imgData:[], //图片数据
            };
            $scope.page = {
                STARTPAGE: '0',
                PAGESIZE: '8'
            }
        }

        /** [initData description]初始化数据 */
        function initData() {
            $scope.data.curManu = item;
            requestBmts();
        }

        /**
         * [showMore description]滚轮showmore
         * @return {[type]} [description]
         */
        $scope.showMore = function() {
            $scope.page.STARTPAGE++;
            requestBmts();
        }

        /**
         * 请求版面
         * @return {[type]} [description]
         */
        function requestBmts() {
            var params = {
                typeid: "widget",
                serviceid: "channelPaperHotpointMgr",
                modelid: "getBmts",
                id: $scope.data.curManu.ID,
                page_no: $scope.page.STARTPAGE,
                page_size: $scope.page.PAGESIZE
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
                if (data.PAGEITEMS && data.PAGEITEMS.length > 0) {
                    for (let i = 0; i < data.PAGEITEMS.length; i++) {
                        if (data.PAGEITEMS[i].JPGPATH) {
                            $scope.data.imgData = $scope.data.imgData.concat(data.PAGEITEMS[i]);
                            let strArr = data.PAGEITEMS[i].JPGPATH.split('/');
                            let strId = strArr[strArr.length - 1].split('.')[0].substr(-8);
                            data.PAGEITEMS[i].id = strId + Math.ceil(Math.random() * 1000); // 计算出id，唯一标识
                            initImg(data.PAGEITEMS[i]);
                        }
                    }
                    $scope.page = {
                        STARTPAGE: data.PAGEINDEX,
                        PAGESIZE: '8',
                        ITEMCOUNT: data.TOTALITEMCOUNT,
                        PAGECOUNT: data.TOTALPAGECOUNT
                    }
                }
            });
        }

        /**
         * [initImg description]初始化图片
         * @return {[type]} [description]
         */
        function initImg(itemchild) {
            $("<img/>").attr("src", itemchild.JPGPATH).load(function() {
                var containerWidth = $(".img_box").width();
                var realWidth = this.width;
                var realHeight = this.height;
                var aspectRatio = realWidth / realHeight;
                var height = parseInt(containerWidth / aspectRatio);
                $("#Img_a_image" + itemchild.id).css({ 'width': containerWidth, 'height': height });
                $("#Img_a" + itemchild.id).css({ 'width': containerWidth, 'height': height });
                $("#Img_a_canvas" + itemchild.id).attr({ 'width': containerWidth, 'height': height });

                var newCoor = CoordMax(itemchild.BMZB, containerWidth, height, realWidth, realHeight);
                var canvasId = 'Img_a_canvas' + itemchild.id;
                setAreaOver(newCoor, canvasId, '71,134,255', '71,134,255', '0.2');

            });
        }

        /**
         * [setAreaOver description]
         * @param {[type]} coords [description]canvas坐标
         * @param {[type]} id     [description]canvasId
         * @param {[type]} b      [description]
         * @param {[type]} c      [description]覆盖区域颜色
         * @param {[type]} o      [description]透明度
         */
        function setAreaOver(coords, id, b, c, o) {

            var canvascheck = document.createElement('canvas');
            var isVM = document.namespaces ? 1 : 0;
            var isCV = canvascheck.getContext ? 1 : 0;

            if (isVM) {
                if (document.namespaces['v'] == null) {
                    var stl = document.createStyleSheet();
                    //stl.addRule("v\\:*", "behavior: url(#default#VML); antialias: true;");

                    document.namespaces.add("v", "urn:schemas-microsoft-com:vml");
                }
            }

            var i, j, x, y, context, p = '',
                canvas = document.getElementById(id);
            var v = coords.split(",");
            //  先清除
            if (isVM) { canvas.innerHTML = ''; }
            if (isCV) {
                var context = canvas.getContext("2d");
                context.clearRect(0, 0, canvas.width, canvas.height);
            }

            // 开始画
            if (isVM) {
                for (j = 2; j < v.length; j += 2) { p += parseInt(v[j]) + ',' + parseInt(v[j + 1]) + ','; }
                canvas.innerHTML = '<v:shape strokeweight="1" filled="t" stroked="' + (n < 1 ? "t" : "f") + '" strokecolor="#' + b + '" coordorigin="0,0" coordsize="' + canvas.width + ',' + canvas.height + '" path="m ' + parseInt(v[0]) + ',' + parseInt(v[1]) + ' l ' + p + ' x e" style="zoom:1;margin:0;padding:0;display:block;position:absolute;top:0px;left:0px;width:' + canvas.width + 'px;height:' + canvas.height + 'px;"><v:fill color="#' + c + '" opacity="' + o + '" /></v:shape>';
            }
            if (isCV) {
                context.moveTo(v[0], v[1]);
                for (j = 2; j < v.length; j += 2) { context.lineTo(v[j], v[j + 1]); }
                context.closePath();
                context.fillStyle = 'rgba(' + c + ',' + o + ')';
                context.strokeStyle = 'rgba(' + b + ',0)'; //边框线暂时为透明
                context.fill();
                context.stroke();
                fadeCanvas(id, 0);
            }
        }

        /**
         * [CoordMax description]按比例计算新的coord坐标
         * @param {[type]} coord [description]old coord
         * @param {[type]} w     [description]画布宽
         * @param {[type]} h     [description]画布高
         * @param {[type]} realW [description]
         * @param {[type]} realH [description]
         */
        function CoordMax(coord, w, h, realW, realH) {
            var arrays = coord.split(',');
            var cd;
            var newCoord = arrays.map(function(v, k) {
                if ((k % 2) == 0) {
                    cd = v / realW * w;
                } else {
                    cd = v / realH * h;
                }
                return cd.toFixed(2);
            }, this).toString();
            return newCoord;
        }

        function fadeCanvas(id, opac) {
            var obj = document.getElementById(id);
            if (opac <= 100) {
                obj.style.opacity = opac / 100;
                opac += 10;
                window.setTimeout(fadeCanvas(id, opac), 10);
            }
        }

        /** [cancel description] 关闭弹窗*/
        $scope.confirm = function() {
            $modalInstance.dismiss();
        };

        /** [cancel description] 关闭弹窗*/
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
    }]);